// extracted by css-extract-rspack-plugin
export default {"section":"section-fpP2Di","label":"label-gjphwW"};